<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1300 1700">
    <MapLayer :shop-map-ids="shopMapIds" />
    <WardNameLayer />
    <g id="yokohama-clickable-group" data-name="clickable_map">
      <template v-for="item in this.mapItems">
        <polygon
          :key="item.id"
          :id="`yokohama-${item.name_en}`"
          tabindex="0"
          role="radio"
          :aria-label="item.name"
          :aria-checked="isChecked(item.id)"
          :points="item.points"
          class="map-selector"
          @click="selectArea(item.id)"
        />
      </template>
    </g>
    <MarkLayer />
  </svg>
</template>

<script>
import MapLayer from './MapLayer.vue';
import MarkLayer from './MarkLayer.vue';
import WardNameLayer from './WardNameLayer.vue';

export default {
  components: {
    MapLayer,
    MarkLayer,
    WardNameLayer,
  },
  props: ['mapAreaId', 'shopMapIds'],
  data: () => ({
    selectedArea: '',
  }),
  computed: {
    mapItems() {
      return [
        {
          id: 10,
          name: this.$t('kanagawa_ku'),
          name_en: 'kanagawa-ku',
          points:
            '737.644 694.844 957.375 763.333 1081 620 957.375 505.86 918.5 588.5 789.5 588.5 641 515 555.678 573.118 737.644 694.844',
        },
        {
          id: 11,
          name: this.$t('nishi_ku'),
          name_en: 'nishi-ku',
          points:
            '737.644 694.844 957.375 763.333 877.334 933.209 756.138 917.266 737.644 694.844',
        },
        {
          id: 12,
          name: this.$t('minami_ku'),
          name_en: 'minami-ku',
          points:
            '737.644 1145.5 904.437 1002.875 877.334 933.209 756.138 917.266 555.678 965.243 573.143 1078.944 737.644 1145.5',
        },
        {
          id: 13,
          name: this.$t('naka_ku'),
          name_en: 'naka-ku',
          points:
            '943 1102 877.334 933.209 915.819 851.035 1194.544 948.179 1166.011 1215.5 943 1102',
        },
        {
          id: 14,
          name: this.$t('tsurumi_ku'),
          name_en: 'tsurumi-ku',
          points:
            '957.375 505.86 988.5 338.5 1119.315 314.004 1292.5 599.5 1172.305 663.132 1081 620 957.375 505.86',
        },
        {
          id: 15,
          name: this.$t('hodogaya_ku'),
          name_en: 'hodogaya-ku',
          points:
            '478.339 573.118 506.657 776.75 428.477 876.38 555.678 965.243 756.138 917.266 737.644 694.844 555.678 573.118 478.339 573.118',
        },
        {
          id: 16,
          name: this.$t('isogo_ku'),
          name_en: 'isogo-ku',
          points:
            '649.459 1478.09 737.644 1145.5 904.437 1002.875 943 1102 932.669 1243 855.5 1420 649.459 1478.09',
        },
        {
          id: 17,
          name: this.$t('kanazawa_ku'),
          name_en: 'kanazawa-ku',
          points:
            '649.459 1478.09 619.25 1586.5 798.333 1693.667 982.124 1547.5 989.845 1364.5 932.669 1243 855.5 1420 649.459 1478.09',
        },
        {
          id: 18,
          name: this.$t('kohoku_ku'),
          name_en: 'kohoku-ku',
          points:
            '798.5 158 1022 169.25 957.375 505.86 918.5 588.5 789.5 588.5 641 515 644.465 461.849 755 434 798.5 158',
        },
        {
          id: 19,
          name: this.$t('totsuka_ku'),
          name_en: 'totsuka-ku',
          points:
            '279.5 891.5 428.477 876.38 555.678 965.243 565.076 1026.424 479 1037.562 440 1262.808 281 1406.5 94.348 1259.848 301.436 1094.5 279.5 891.5',
        },
        {
          id: 20,
          name: this.$t('konan_ku'),
          name_en: 'konan-ku',
          points:
            '440 1262.808 479 1037.562 565.076 1026.424 573.143 1078.944 737.644 1145.5 665.645 1420 440 1262.808',
        },
        {
          id: 21,
          name: this.$t('asahi_ku'),
          name_en: 'asahi-ku',
          points:
            '143.019 576.5 478.339 573.118 506.657 776.75 428.477 876.38 279.5 891.5 143.019 576.5',
        },
        {
          id: 22,
          name: this.$t('midori_ku'),
          name_en: 'midori-ku',
          points:
            '644.465 461.849 641 515 555.678 573.118 143.019 576.5 112.451 505.86 84 412.596 129.5 324.5 440 336.5 473.401 475.489 644.465 461.849',
        },
        {
          id: 23,
          name: this.$t('seya_ku'),
          name_en: 'seya-ku',
          points:
            '12.5 557.5 112.451 505.86 279.5 891.5 48.5 938.244 12.5 557.5',
        },
        {
          id: 24,
          name: this.$t('sakae_ku'),
          name_en: 'sakae-ku',
          points:
            '281 1406.5 440 1262.808 665.645 1420 619.25 1586.5 281 1406.5',
        },
        {
          id: 25,
          name: this.$t('izumi_ku'),
          name_en: 'izumi-ku',
          points:
            '48.5 938.244 94.348 1259.848 301.436 1094.5 279.5 891.5 48.5 938.244',
        },
        {
          id: 26,
          name: this.$t('aoba_ku'),
          name_en: 'aoba-ku',
          points:
            '114.5 159.5 450.5 14 578 77 440 336.5 129.5 324.5 114.5 159.5',
        },
        {
          id: 27,
          name: this.$t('tsuzuki_ku'),
          name_en: 'tsuzuki-ku',
          points:
            '440 336.5 578 77 798.5 158 755 434 644.465 461.849 473.401 475.489 440 336.5',
        },
      ];
    },
  },
  mounted: function() {
    this.selectedArea = this.mapAreaId;
  },
  methods: {
    selectArea(value) {
      if (this.shopMapIds && !this.shopMapIds.includes(value)) return;
      this.selectedArea = value;
      this.$emit('input', value);
      this.$emit('changeMapArea');
    },
    isChecked(value) {
      return this.selectedArea === value;
    },
  },
};
</script>

<style scoped>
.map-selector {
  fill: transparent;
  stroke: transparent;
  stroke-linejoin: round;
  stroke-width: 8px;
}
.map-selector:focus {
  outline: none;
}
.map-selector[aria-checked='true'] {
  stroke: #B22C27;
  stroke-width: 16px;
}
</style>
